import { Component } from '@angular/core';

@Component({
  selector: 'app-home-steps-v2',
  templateUrl: './home-steps-v2.component.html',
  styleUrl: './home-steps-v2.component.scss'
})
export class HomeStepsV2Component {

}
